import $ from 'jquery';
import TemplateIcons from 'bloko/blocks/treeSelector/treeSelectorIcons.mustache';

const DATA_QA_ITEM = 'bloko-tree-selector-item';
const DATA_QA_ITEM_EXPANDED = 'bloko-tree-selector-item bloko-tree-selector-item-expanded';

export default function(modelsHandler) {
    modelsHandler.on('change:selected', (model) => {
        model.view.input.checked = model.attributes.selected;
    });

    modelsHandler.on('change:expanded', (model) => {
        if (!model.view.$icon) {
            model.view.$icon = $(model.view.icon);
        }

        if (!model.view.$list) {
            model.view.$list = $(model.view.list);
        }
        cacheItemNode(model);

        getVisibleDescendants(model).forEach((model) => {
            if (model.view.input) {
                model.view.input.disabled = !!model.attributes.disabled;
            }
        });

        model.view.$icon.html(TemplateIcons.render({ expanded: model.attributes.expanded }));
        model.view.$list.toggleClass('g-hidden');
        model.view.$el.attr('data-qa', model.attributes.expanded ? DATA_QA_ITEM_EXPANDED : DATA_QA_ITEM);
    });

    modelsHandler.on('change:indeterminate', (model) => {
        model.view.input.indeterminate = model.attributes.indeterminate;
    });

    modelsHandler.on('change:disabled', (model) => {
        if (model.view.input && isVisible(model)) {
            model.view.input.disabled = !!model.attributes.disabled;
        }
    });

    modelsHandler.on('change:hidden', (model) => {
        cacheItemNode(model);
        model.view.$el.toggleClass('g-hidden', model.attributes.hidden);
    });

    function cacheItemNode(model) {
        if (!model.view.$el) {
            model.view.$el = $(model.view.el);
        }
    }

    function getVisibleDescendants(model) {
        const items = model.attributes.items;
        if (!model.attributes.expanded || !items || !items.length) {
            return [];
        }

        const nestedVisibleModels = items.reduce((result, model) => {
            const descendants = getVisibleDescendants(model);
            if (descendants.length) {
                Array.prototype.push.apply(result, descendants);
            }
            return result;
        }, []);

        return items.concat(nestedVisibleModels);
    }

    function isVisible(model) {
        let parent = model.attributes.parent;
        while (parent) {
            if (!parent.attributes.expanded) {
                return false;
            }
            parent = parent.attributes.parent;
        }
        return true;
    }
}
